import React, { FunctionComponent } from "react";
import "./widget.css";
import "./humidity.css"
import { weatherData } from "../../types/weather";

type Props = {
  data?: weatherData;
};

const HumidityWidget: FunctionComponent<Props> = (props: Props) => {

  return (
    <>
      <span className="widget-title">Humidité</span>
      <div>
        <span className="widget-humidity-data" >{props.data?.actual.rain.humidity} %</span>
      </div>
      <div className="widget-footer"></div>
    </>
  )
}

export default HumidityWidget;
